import backendURL from "./config";

export const addgallery = async (image, desp) => {
  try {
    const response = await backendURL.post("gallery/register", {
      image,
      desp,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error adding to gallery:", error);
    throw error;
  }
};

export const viewgallery = async (page, pageSize) => {
  try {
    const response = await backendURL.post("gallery/view", { page, pageSize });
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to fetch categories"
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("Something went wrong. Please try again.");
    }
  }
};

export const viewall = async () => {
  try {
    const response = await backendURL.get("gallery/viewWithoutPagination");
    return response.data.data;
  } catch (error) {
    console.error("Error viewing gallery:", error);
    throw error;
  }
};
